import React, { FC } from 'react'
import styles from './MapStylesMenu.module.scss'
import { useTranslation } from 'react-i18next'
import { Tooltip } from 'components/Tooltip'

type MapStylesMenuProps = {
  onLightMapClick: any
  onDarkMapClick: any
  onSatelliteMapClick: any
  onStreetMapClick: any
}

export const MapStylesMenu: FC<MapStylesMenuProps> = ({
  onLightMapClick,
  onDarkMapClick,
  onSatelliteMapClick,
  onStreetMapClick,
}) => {
  const { t } = useTranslation()
  const [menuActive, setMenuActive] = React.useState<boolean>(false)

  const buttonStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '30px',
    height: '30px',
    border: 'none',
    background: 'none',
    backgroundColor: '#fff',
    padding: '0',
    cursor: 'pointer',
  }

  const buttonContainerStyles = {
    cursor: 'pointer',
    backgroundColor: '#fff',
  }

  return (
    <div className={styles.mapStylesMenu}>
      {menuActive && (
        <nav className={styles.mapStylesNav}>
          <div style={buttonContainerStyles}>
            <button onClick={onLightMapClick} style={buttonStyles}>
              <Tooltip label={t('map.tools.map_visualization.light')} direction="LEFT_CENTER">
                <img
                  src="https://report.descifra.global/ImagenesCarto/mapa_light.png"
                  alt="mapa_light"
                ></img>
              </Tooltip>
            </button>
          </div>
          <div style={buttonContainerStyles}>
            <button onClick={onDarkMapClick} style={buttonStyles}>
              <Tooltip label={t('map.tools.map_visualization.dark')} direction="LEFT_CENTER">
                <img
                  src="https://report.descifra.global/ImagenesCarto/mapa_dark.png"
                  alt="mapa_dark"
                ></img>
              </Tooltip>
            </button>
          </div>
          <div style={buttonContainerStyles}>
            <button onClick={onSatelliteMapClick} style={buttonStyles}>
              <Tooltip label={t('map.tools.map_visualization.satelite')} direction="LEFT_CENTER">
                <img
                  src="https://report.descifra.global/ImagenesCarto/mapa_satelite.png"
                  alt="mapa_satelite"
                ></img>
              </Tooltip>
            </button>
          </div>
          <div style={buttonContainerStyles}>
            <button onClick={onStreetMapClick} style={buttonStyles}>
              <Tooltip label={t('map.tools.map_visualization.street')} direction="LEFT_CENTER">
                <img
                  src="https://report.descifra.global/ImagenesCarto/mapa_street.png"
                  alt="mapa_streets"
                ></img>
              </Tooltip>
            </button>
          </div>
        </nav>
      )}

      <div style={buttonContainerStyles}>
        <button onClick={() => setMenuActive(!menuActive)} style={buttonStyles}>
          <Tooltip label={t('map.tools.map_visualization.menu')} direction="LEFT_CENTER">
            <img src="https://report.descifra.global/ImagenesCarto/mapa_ic.png" alt="mapa_ic"></img>
          </Tooltip>
        </button>
      </div>
    </div>
  )
}

MapStylesMenu.displayName = 'MapStylesMenu'
